// Date helpers that anchor "today" to America/New_York (Eastern) instead of UTC.
// After 8 PM ET, new Date().toISOString() returns tomorrow's UTC date, which
// broke the clock-out flow. All DB work_date math should go through these.

var ET_TZ = 'America/New_York'

function formatPartsEastern(date) {
  var parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ET_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)
  var year = parts.find(function(p) { return p.type === 'year' }).value
  var month = parts.find(function(p) { return p.type === 'month' }).value
  var day = parts.find(function(p) { return p.type === 'day' }).value
  return year + '-' + month + '-' + day
}

// Today's date in Eastern time, as YYYY-MM-DD.
export function getTodayEastern() {
  return formatPartsEastern(new Date())
}

// Convert any Date (or ISO string) to its YYYY-MM-DD in Eastern time.
export function getDateInEastern(dateOrIso) {
  var d = dateOrIso instanceof Date ? dateOrIso : new Date(dateOrIso)
  return formatPartsEastern(d)
}

// YYYY-MM-DD for N days before today in Eastern time.
// Computes against the Eastern-anchored "today" so it doesn't drift at UTC rollover.
export function getDaysAgoEastern(days) {
  var todayET = getTodayEastern() // "YYYY-MM-DD"
  // Interpret todayET as noon ET to avoid DST edge cases, then subtract days.
  var d = new Date(todayET + 'T12:00:00-05:00') // fixed offset is fine, we only use the date
  d.setUTCDate(d.getUTCDate() - days)
  return formatPartsEastern(d)
}

export function getYesterdayEastern() {
  return getDaysAgoEastern(1)
}

// Format an ISO timestamp as "3:45 PM" in Eastern time.
export function formatTimeEastern(iso) {
  if (!iso) return '--'
  return new Date(iso).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: ET_TZ,
  })
}
